const SLUG_QUERIES: Record<string, string> = {
  // Industry
  'real-estate':  'real estate property agent',
  'healthcare':   'hospital doctor medical professional',
  'education':    'classroom learning education student',
  'ecommerce':    'ecommerce online shopping website',
  'finance':      'finance banking investment money',
  'hospitality':  'hotel hospitality service reception',
  'insurance':    'insurance office professional business',
  'legal':        'lawyer legal office professional',
  'retail':       'retail store shopping customer',
  'saas':         'software technology SaaS startup',
  // Use-case
  'customer-service':     'customer service support helpdesk',
  'sales-assistant':      'sales business handshake meeting',
  'hr-onboarding':        'HR onboarding office employee',
  'lead-generation':      'lead generation marketing funnel',
  'product-demo':         'product demo presentation laptop',
  'faq-automation':       'FAQ automation chatbot technology',
  'appointment-booking':  'appointment booking calendar schedule',
  'training-coaching':    'training coaching workshop education',
  // Comparison
  'synthesia':    'video AI avatar technology',
  'heygen':       'AI video generation technology',
  'd-id':         'AI avatar digital identity',
  'did-studio':   'digital studio production technology',
  'tavus':        'AI video personalization technology',
  'colossyan':    'AI avatar workplace training',
  'akool':        'AI video marketing creative',
  'convai':       'conversational AI chat technology',
};

function slugToHash(slug: string): number {
  let hash = 0;
  for (let i = 0; i < slug.length; i++) hash = (hash * 31 + slug.charCodeAt(i)) & 0xfffff;
  return hash;
}

export function getPseoImageUrl(slugKey: string, width = 800, height = 400): string {
  if (SLUG_QUERIES[slugKey]) {
    return `/pseo-images/${slugKey}.jpg`;
  }
  const hash = slugToHash(slugKey);
  return `https://loremflickr.com/${width}/${height}/technology?lock=${hash % 200}`;
}
